module.exports = "/dist/images/8d4f3d87e83fbaa931391a8b93cb3cc2-sodexo.png";